module.exports = __webpack_public_path__ + "icoEvents.png";